import NotificationsDropdown, { AppNotification } from "../notifications/NotificationsDropdown";
import useWorkOrders from "../../data/useWorkOrders";
import { useEffect, useState } from "react";
import useAppNotifications from "../../data/useAppNotifications";
import openInNewTab from "../../utils/openInNewTab";

export default function WorkOrderNotifications() {
  const { workOrderNotifications } = useAppNotifications();
  const [notifications, setNotifications] = useState<AppNotification[]>([]);

  useEffect(() => {
    if (workOrderNotifications.isLoading) return;
    if (!workOrderNotifications.data || !workOrderNotifications.data.data) {
      setNotifications([]);
      return;
    }

    setNotifications(workOrderNotifications.data.data);
  }, [workOrderNotifications.isLoading, workOrderNotifications.data]);     


  return (
    <>
      <NotificationsDropdown 
        notifications={notifications} 
        onNotificationClick={(notification => {
          openInNewTab(`/work-orders`); // Assuming linkedId is the work order ID
        })}
      />
    </>
  )
}

function formatDate(dateValue: string | null): string {
  if (!dateValue) return "-";

  const date = new Date(dateValue);
  if (isNaN(date.getTime())) return "-";

  return date.toLocaleDateString("en-GB");
}